import {useQuery} from '@tanstack/react-query'
import {NexusService} from 'global-apis/nexus-service'

export function useInsurance(customerId: string, subscriptionId: string) {

  function cancelInsurance() {
    const {
      data: success,
      refetch,
    } = useQuery({
      queryKey: ['/cancelInsurance'],
      queryFn: () =>
        NexusService.cancelInsurancePolicy(subscriptionId).then((res) => {
          return res
        }),
      refetchOnWindowFocus: false,
      enabled: false,
    }
    )
    return {
      success,
      doCancelInsurance: refetch,
    }
  }

  function upsertInsurancePolicies(policyNumber: string, providerName: string, effectiveDate: number, expirationDate: number) {
    const {
      data: success,
      refetch,
    } = useQuery({
      queryKey: ['/upsertInsurancePolicies'],
      queryFn: () =>
        NexusService.upsertInsurancePolicies(policyNumber, providerName, effectiveDate, expirationDate, customerId, subscriptionId).then((res) => {
          return res
        }),
      refetchOnWindowFocus: false,
      enabled: false,
    }
    )
    return {
      success,
      doUpsertInsurancePolicies: refetch,
    }
  }

  return {
    cancelInsurance,
    upsertInsurancePolicies,
  }
}
